import { Spacing } from '@kezios/design-system';
import { Button, Flex } from '@mantine/core';
import { LinkWithQueryParams } from 'components/website/components/atoms/LinkWithQueryParams/LinkWithQueryParams';
import { TrialDecoration } from 'components/website/components/molecules/TrialDecoration/TrialDecoration';
import { useTranslations } from 'next-intl';

import css from './HeroCta.module.css';

export const HeroCta = ({ currentLocale }: { currentLocale: string }) => {
  const t = useTranslations('section.hero.cta');

  return (
    <Flex direction={'column'} gap={Spacing.s10}>
      <div className={css.buttonContainer}>
        <Button
          variant="filled"
          w={'fit-content'}
          size="xl"
          component={LinkWithQueryParams}
          locale={currentLocale}
          href="/download/"
        >
          {t('button')}
        </Button>
        <TrialDecoration />
      </div>
    </Flex>
  );
};
